import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import cn from 'classnames'
import Typography from '../Typography'
import { School } from '../../models/_models'
import useReformattedSchedules from './use-reformatted-schedules'
import { dbDateFormat } from '../../utils/functions'
import classes from './shooting-schedules.module.sass'
import { customStyles } from '../_pages/schedule-appointment';

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

const APPT_LENGTH = 300_000

const ShootingSchedules = ({
  schedules, setAppt, selectedOption, initialSelectedDay, initialSelectedTime, school, setIsApptAtShoob
}) => {
  const [selectedDay, setSelectedDay] = useState(initialSelectedDay)
  const [selectedTime, setSelectedTime] = useState(initialSelectedTime)
  const [apptTimeframe, setApptTimeframe] = useState(5) // 5 minute default timeframe
  const reformattedSchedules = useReformattedSchedules(schedules, selectedOption.appointmentValue, school && school.id, apptTimeframe)

  useEffect(() => {
    School
      .selectExtra(['appointmentInterval'])
      .find(school.id)
      .then((res) => {
        // convert minutes to milliseconds
        const timeframe = res.data.appointmentInterval

        setApptTimeframe(timeframe)
      })
  }, [])

  useEffect(() => {
    if (selectedDay && selectedTime) {
      const [timeValue, suffix] = selectedTime.value.split(' ')
      let [hours, minutes] = timeValue.split(':')

      if (suffix === 'PM' && hours !== '12') {
        hours = (parseInt(hours, 10) + 12).toString()
      }

      if (hours.length === 1) hours = `0${hours}`

      const formattedTime = `${hours}:${minutes}:00`

      const selectedDayParts = selectedDay.value.split('@')

      if (selectedDayParts.length > 1) setIsApptAtShoob(true)

      setAppt(dbDateFormat(`${selectedDayParts[0].trim()}T${formattedTime}+00:00`))
    }
    else setAppt(null)
  }, [selectedDay, selectedTime])

  if (Object.keys(reformattedSchedules).length === 0) return null

  const isMobile = navigator.maxTouchPoints > 1

  return (
    <div>
      <label>
        <Typography>Select Date</Typography>
        {
          <Select
            className={cn(classes.apptSelect, classes.mb2)}
            styles={customStyles}
            placeholder="Choose one"
            value={selectedDay}
            onChange={(opt) => {
              setSelectedDay(opt)
              setSelectedTime(null)
            }}
            options={Object.keys(reformattedSchedules).map((day) => {
              const date = new Date(Date.parse(`${day.split('@')[0].trim()}T12:00:00`))
              const suffix = day.split('@').length > 1 ? ' @ Shoob Photo Studio' : ''
              const label = `${MONTHS[date.getMonth()]}, ${date.getUTCDate()}${suffix}`

              return { value: day, label }
            })}
          />
        }
      </label>
      {selectedDay && (
        <>
          <Typography>Select Time</Typography>
          {isMobile ? (
            <select
              className={classes.nativeSelect}
              value={selectedTime && selectedTime.value}
              onChange={(evt) => {
                if (evt.target.value === '') return

                setSelectedTime({ value: evt.target.value, label: '' })
              }}
            >
              <option value="" disabled selected>Choose one</option>
              {(reformattedSchedules[selectedDay.value] || [])
                .map((timeslot) => {
                  const fiveMinutesFromStart = new Date(Date.parse(`August 19, 1975 ${timeslot.time}`) + (selectedOption.appointmentValue * 60 * 1000))

                  const time = fiveMinutesFromStart.toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit',
                  })

                  return <option value={timeslot.time}>{`${timeslot.time} - ${time}`}</option>
                })}
            </select>
          ) : (
            <Select
              styles={customStyles}
              placeholder="Choose one"
              noOptionsMessage={() => 'No appointments are available on this date. Please try another day or contact Shoob Photography at (209) 567-0748 ext 1.'}
              value={selectedTime}
              onChange={(opt) => setSelectedTime(opt)}
              options={
                (reformattedSchedules[selectedDay.value] || [])
                  .map((timeslot) => {
                    const fiveMinutesFromStart = new Date(Date.parse(`August 19, 1975 ${timeslot.time}`) + (selectedOption.appointmentValue * 60 * 1000))

                    const time = fiveMinutesFromStart.toLocaleTimeString([], {
                      hour: '2-digit',
                      minute: '2-digit',
                    })

                    return { value: timeslot.time, label: `${timeslot.time} - ${time}` }
                  })
              }
            />
          )}
        </>
      )}
    </div>
  )
}

ShootingSchedules.propTypes = {
  schedules: PropTypes.array.isRequired,
  setAppt: PropTypes.func.isRequired,
  setIsApptAtShoob: PropTypes.func.isRequired,
}

export default ShootingSchedules
